
(function () {
  var BREAKPOINT = 767; // mobile: szerokość <= 767px

  var SOURCE_SEL = '.wt-header__body--search-no-button'; // kontener źródłowy
  var ITEM_SEL   = '.Vtl-WishlistHeaderWrapper';          // element do przeniesienia
  var TARGET_SEL = '.wt-header__panel--no-labels';        // kontener docelowy

  var placeholder = null; // znacznik pierwotnej pozycji (do przywrócenia na desktopie)

  function isMobile() {
    return window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').matches;
  }

  function moveWishlist() {
    var item = document.querySelector(ITEM_SEL);
    if (!item) return;

    var target = document.querySelector(TARGET_SEL);
    var source = document.querySelector(SOURCE_SEL);

    if (isMobile()) {
      // upewnij się, że mamy dokąd przenieść
      if (!target) return;

      // zostaw znacznik pierwotnego miejsca, jeśli jeszcze go nie ma
      if (!placeholder) {
        placeholder = document.createComment('wishlist-placeholder');
        item.parentNode.insertBefore(placeholder, item);
      }

      // przenieś na DÓŁ kontenera docelowego, jeśli nie jest już tam ostatni
      if (item.parentNode !== target || target.lastElementChild !== item) {
        target.appendChild(item);
      }
    } else {
      // desktop: przywróć na pierwotne miejsce
      if (placeholder && placeholder.parentNode) {
        placeholder.parentNode.insertBefore(item, placeholder);
        placeholder.parentNode.removeChild(placeholder);
        placeholder = null;
      }
    }
  }

  // reaguj na zmianę szerokości okna
  window.matchMedia('(max-width: ' + BREAKPOINT + 'px)').addEventListener('change', moveWishlist);
  window.addEventListener('resize', moveWishlist);

  // pierwsze uruchomienie
  if (document.readyState !== 'loading') {
    moveWishlist();
  } else {
    document.addEventListener('DOMContentLoaded', moveWishlist);
  }

  // wishlist ładuje się często asynchronicznie -> obserwuj DOM
  var observer = new MutationObserver(function () {
    moveWishlist();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
